import { auth } from '@/firebaseConfig';
import { API_ENDPOINTS } from '@/apiConfig';
import axiosClient from '@/axiosClient';

export function useCreateComplaint() {

    const createComplaint = async (complaintData) => {
        try {
            const currentUser = auth.currentUser;
            if (!currentUser) {
                throw new Error('User not authenticated');
            }

            const formattedData = {
                priority: complaintData.priority,
                subject: complaintData.subject,
                complaint_date: complaintData.complaintDate,
                ticket_type: 'complaint',
                status: 'open',
                employee: {
                    id: complaintData.employee.employee_id,
                    name: complaintData.employee.employee_name,
                    email: complaintData.employee.employee_email,
                    department: complaintData.employee.department || ''
                },
                company: {
                    id: complaintData.employee.employee_company_id,
                    name: complaintData.employee.employee_company_name,
                    short_name: complaintData.employee.employee_company_short_name || ''
                },
                posts: [
                    {
                        type: 'initial',
                        user_id: currentUser.uid,
                        user_email: currentUser.email,
                        status: 'open',
                        message: complaintData.message,
                        mailer_status: false,
                        read_receipt: false,
                        read_acknowledge: true, // for initial post we set to true
                        timestamp: new Date().toISOString(),
                    }
                ]
            };

            // Use axios to post to the API endpoint
            const response = await axiosClient.post(API_ENDPOINTS.createTicket, formattedData);
            
            // The API should return the created complaint with an ID
            const newComplaintData = response.data;

            return newComplaintData;
        } catch (error) {
            console.error('Error creating complaint:', error);
            throw error;
        }
    };

    return {
        createComplaint
    };
}
